import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js"

export default class extends Controller {
  static values = {
    updatePath: String,
    paramsKey: String
  }

  toggleDefaultSwipeToOpen(event) {
    this.sendRequest({ default_swipe_to_open_enabled: event.target.checked ? 1 : 0 })
  }

  sendRequest(params) {
    put(this.updatePathValue, {
      body: { [this.paramsKeyValue]: params },
      responseKind: "json"
    })
  }
}
